import type { CardClient } from '@atlaskit/link-provider';

import type { ManagedBlockConfigurationUpdate } from '../configuration';

import type { ManagedBlockSource, ManagedBlockSourceMode } from './types';
import { useResolveSources } from './useResolveSources';
import { useSourceInput } from './useSourceInput';

type UseSourcesArgs = {
	cardClient: CardClient;
	onChange: (update: ManagedBlockConfigurationUpdate) => void;
	onConfigEdit: () => void;
	onInteraction: () => void;
	sourceEntries: ManagedBlockSource[];
	sourceMode: ManagedBlockSourceMode;
	sourceUrls: string;
};

type UseSourcesResult = ReturnType<typeof useSourceInput> & {
	manualSources: ManagedBlockSource[];
};

export const useSources = ({
	cardClient,
	onChange,
	onConfigEdit,
	onInteraction,
	sourceEntries,
	sourceMode,
	sourceUrls,
}: UseSourcesArgs): UseSourcesResult => {
	useResolveSources({
		cardClient,
		onChange,
		sourceEntries,
	});

	const sourceInput = useSourceInput({
		onChange,
		onConfigEdit,
		onInteraction,
		sourceEntries,
		sourceMode,
		sourceUrls,
	});

	return {
		manualSources: sourceEntries,
		...sourceInput,
	};
};
